import styled from "@emotion/styled";
import {colors, sizes} from "patient-ping-remedy/packages/theme";

export const RadioButtonWrapper = styled.div`
    border: 1px solid ${colors.gray2};
    border-radius: 0.5rem;
    padding: ${sizes.small};
    margin-bottom: 1.6rem;
    cursor: pointer;
    
    input:checked + span {
        background-color: ${colors.white};
        border-color: ${colors.primary1};
    }
    
    div:first-of-type {
        margin-top:  ${sizes.xSmall} !important;
    }
    
    input:checked + span::after {
        background-color: ${colors.primary1};
    }
`;

export const PerformedByLabel = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: ${sizes.medium};
    margin-top: -1rem;
`;
